export const reactQuizData = [
    {
        module: "Day 1 – What is React & Why Use It?",
        questions: [
            {
                id: "r-1-1",
                question: "What is React?",
                options: [
                    "A back-end server framework",
                    "A JavaScript library for building user interfaces",
                    "A CSS styling framework",
                    "A database management system",
                ],
                answer: "A JavaScript library for building user interfaces",
            },
            {
                id: "r-1-2",
                question: "Who created React?",
                options: ["Google", "Microsoft", "Meta (Facebook)", "Twitter"],
                answer: "Meta (Facebook)",
            },
            {
                id: "r-1-3",
                question: "What is the Virtual DOM?",
                options: [
                    "A copy of the real DOM that React uses to efficiently update the browser",
                    "A new HTML tag introduced by React",
                    "A virtual server for React applications",
                    "A type of React component",
                ],
                answer: "A copy of the real DOM that React uses to efficiently update the browser",
            },
            {
                id: "r-1-4",
                question: "What is the main advantage of using React over plain JavaScript?",
                options: [
                    "React runs faster on servers",
                    "React provides a component-based model for building reusable UI pieces",
                    "React automatically writes CSS",
                    "React replaces HTML completely",
                ],
                answer: "React provides a component-based model for building reusable UI pieces",
            },
            {
                id: "r-1-5",
                question: "What command creates a new React app using Create React App?",
                options: [
                    "npm install react",
                    "npx create-react-app my-app",
                    "npm start react",
                    "react init my-app",
                ],
                answer: "npx create-react-app my-app",
            },
            {
                id: "r-1-6",
                question: "What is React primarily designed for?",
                options: [
                    "Back-end API development",
                    "Database queries",
                    "Building the view layer (user interface) of applications",
                    "Server-side rendering only",
                ],
                answer: "Building the view layer (user interface) of applications",
            },
            {
                id: "r-1-7",
                question: "React is described as a library, not a framework. What does this mean?",
                options: [
                    "React cannot work with other tools",
                    "React has fewer features than a framework",
                    "React handles only the UI and can be combined freely with other libraries",
                    "React is only for small projects",
                ],
                answer: "React handles only the UI and can be combined freely with other libraries",
            },
            {
                id: "r-1-8",
                question: "Which file is the entry point of a Create React App project?",
                options: ["App.js", "index.html", "index.js", "main.js"],
                answer: "index.js",
            },
            {
                id: "r-1-9",
                question: "What does ReactDOM.render() (or root.render()) do?",
                options: [
                    "Fetches data from an API",
                    "Mounts the React component tree to a real DOM element",
                    "Compiles JSX to HTML",
                    "Creates a new React component",
                ],
                answer: "Mounts the React component tree to a real DOM element",
            },
            {
                id: "r-1-10",
                question: "What is a React component?",
                options: [
                    "A CSS class",
                    "An independent, reusable piece of UI that returns JSX",
                    "A JavaScript file without any exports",
                    "An HTML attribute",
                ],
                answer: "An independent, reusable piece of UI that returns JSX",
            },
            {
                id: "r-1-11",
                question: "What is SPA in the context of React?",
                options: [
                    "Server-side Page App",
                    "Single Page Application – a web app with one HTML page managed by JavaScript",
                    "Styled Prop Approach",
                    "Static Public Assets",
                ],
                answer: "Single Page Application – a web app with one HTML page managed by JavaScript",
            },
            {
                id: "r-1-12",
                question: "Which of the following is NOT a feature of React?",
                options: [
                    "Component-based architecture",
                    "Virtual DOM",
                    "Built-in database connections",
                    "Declarative UI",
                ],
                answer: "Built-in database connections",
            },
            {
                id: "r-1-13",
                question: "What is meant by 'declarative' programming in React?",
                options: [
                    "You describe WHAT the UI should look like and React handles the HOW",
                    "You manually update the DOM step by step",
                    "You declare all variables at the top of the file",
                    "You control every rendering step explicitly",
                ],
                answer: "You describe WHAT the UI should look like and React handles the HOW",
            },
            {
                id: "r-1-14",
                question: "What is Vite used for in React development?",
                options: [
                    "A CSS styling tool",
                    "A fast build tool and development server for modern JavaScript projects",
                    "A state management library",
                    "A testing framework",
                ],
                answer: "A fast build tool and development server for modern JavaScript projects",
            },
            {
                id: "r-1-15",
                question: "What does npm start do in a React project?",
                options: [
                    "Builds the project for production",
                    "Installs all dependencies",
                    "Starts the local development server",
                    "Runs the tests",
                ],
                answer: "Starts the local development server",
            },
        ],
    },
    {
        module: "Day 2 – JSX & Functional Components",
        questions: [
            {
                id: "r-2-1",
                question: "What is JSX?",
                options: [
                    "A new programming language",
                    "A syntax extension that lets you write HTML-like code inside JavaScript",
                    "A type of CSS preprocessor",
                    "A database query language",
                ],
                answer: "A syntax extension that lets you write HTML-like code inside JavaScript",
            },
            {
                id: "r-2-2",
                question: "Which tool transforms JSX into standard JavaScript?",
                options: ["Webpack", "Babel", "ESLint", "Node.js"],
                answer: "Babel",
            },
            {
                id: "r-2-3",
                question: "How do you embed a JavaScript expression inside JSX?",
                options: [
                    "Using double quotes: \"expression\"",
                    "Using curly braces: {expression}",
                    "Using brackets: [expression]",
                    "Using angle brackets: <expression>",
                ],
                answer: "Using curly braces: {expression}",
            },
            {
                id: "r-2-4",
                question: "Why do you use className instead of class in JSX?",
                options: [
                    "Because class is not allowed in HTML",
                    "Because class is a reserved keyword in JavaScript",
                    "Because className is shorter",
                    "Because React invented its own attribute names",
                ],
                answer: "Because class is a reserved keyword in JavaScript",
            },
            {
                id: "r-2-5",
                question: "What must every React component return?",
                options: [
                    "A plain JavaScript object",
                    "JSX (or null)",
                    "An HTML string",
                    "A CSS class name",
                ],
                answer: "JSX (or null)",
            },
            {
                id: "r-2-6",
                question: "How must adjacent JSX elements be wrapped?",
                options: [
                    "Inside an array",
                    "Inside a single parent element or React Fragment (<> </>)",
                    "Inside a function",
                    "Inside a div only",
                ],
                answer: "Inside a single parent element or React Fragment (<> </>)",
            },
            {
                id: "r-2-7",
                question: "How must custom React component names start?",
                options: [
                    "With a lowercase letter",
                    "With an underscore",
                    "With an uppercase letter",
                    "With the word 'component'",
                ],
                answer: "With an uppercase letter",
            },
            {
                id: "r-2-8",
                question: "What is a functional component in React?",
                options: [
                    "A JavaScript class that extends React.Component",
                    "A plain JavaScript function that returns JSX",
                    "A function that only handles events",
                    "A component stored in a database",
                ],
                answer: "A plain JavaScript function that returns JSX",
            },
            {
                id: "r-2-9",
                question: "What is a React Fragment used for?",
                options: [
                    "To group elements without adding extra DOM nodes",
                    "To create animations",
                    "To fetch data from an API",
                    "To handle routing",
                ],
                answer: "To group elements without adding extra DOM nodes",
            },
            {
                id: "r-2-10",
                question: "How do you apply inline styles in JSX?",
                options: [
                    "style='color: red'",
                    "style={{ color: 'red' }}",
                    "css={{ color: 'red' }}",
                    "className={{ color: 'red' }}",
                ],
                answer: "style={{ color: 'red' }}",
            },
            {
                id: "r-2-11",
                question: "What does the self-closing syntax <MyComponent /> indicate?",
                options: [
                    "The component is empty and has no children",
                    "The component will be removed from the DOM",
                    "The component is a class component",
                    "The component has default props",
                ],
                answer: "The component is empty and has no children",
            },
            {
                id: "r-2-12",
                question: "Which is the correct way to render an array of items in JSX?",
                options: [
                    "items.forEach(item => <li>{item}</li>)",
                    "items.map(item => <li key={item}>{item}</li>)",
                    "for (let item of items) { <li>{item}</li> }",
                    "items.filter(item => <li>{item}</li>)",
                ],
                answer: "items.map(item => <li key={item}>{item}</li>)",
            },
            {
                id: "r-2-13",
                question: "Why does React require a key prop when rendering lists?",
                options: [
                    "To style each list item differently",
                    "To help React identify which items have changed, are added, or removed",
                    "To number the items automatically",
                    "To pass data between components",
                ],
                answer: "To help React identify which items have changed, are added, or removed",
            },
            {
                id: "r-2-14",
                question: "In JSX, how do you add a comment?",
                options: [
                    "// comment",
                    "<!-- comment -->",
                    "{/* comment */}",
                    "/* comment */",
                ],
                answer: "{/* comment */}",
            },
            {
                id: "r-2-15",
                question: "What does conditional rendering mean in React?",
                options: [
                    "Rendering components only on certain devices",
                    "Displaying different UI based on a condition or state",
                    "Rendering components in a specific order",
                    "Applying CSS conditionally",
                ],
                answer: "Displaying different UI based on a condition or state",
            },
        ],
    },
    {
        module: "Day 3 – Props: Passing Data Between Components",
        questions: [
            {
                id: "r-3-1",
                question: "What are props in React?",
                options: [
                    "Internal state variables",
                    "Properties passed from a parent component to a child component",
                    "CSS properties applied to elements",
                    "JavaScript variables declared with let",
                ],
                answer: "Properties passed from a parent component to a child component",
            },
            {
                id: "r-3-2",
                question: "Are props mutable (changeable) inside the child component?",
                options: [
                    "Yes, they can be freely changed",
                    "No, props are read-only in the child component",
                    "Only string props can be changed",
                    "Yes, but only if you use useEffect",
                ],
                answer: "No, props are read-only in the child component",
            },
            {
                id: "r-3-3",
                question: "How do you pass a prop called title with value 'Hello' to a component?",
                options: [
                    "<Card title='Hello' />",
                    "<Card {title: 'Hello'} />",
                    "<Card = title:'Hello' />",
                    "<Card>.title='Hello'</Card>",
                ],
                answer: "<Card title='Hello' />",
            },
            {
                id: "r-3-4",
                question: "How do you receive and use props inside a functional component?",
                options: [
                    "By accessing this.props.title",
                    "By destructuring from the function parameter: ({ title })",
                    "By using useState('title')",
                    "By importing props from React",
                ],
                answer: "By destructuring from the function parameter: ({ title })",
            },
            {
                id: "r-3-5",
                question: "What is the children prop?",
                options: [
                    "A prop that holds all child element values",
                    "Whatever is placed between a component's opening and closing tags",
                    "A list of all nested components",
                    "A special prop for arrays",
                ],
                answer: "Whatever is placed between a component's opening and closing tags",
            },
            {
                id: "r-3-6",
                question: "What are default props used for?",
                options: [
                    "To define required props",
                    "To provide fallback values when a prop is not passed",
                    "To validate prop types",
                    "To share state between components",
                ],
                answer: "To provide fallback values when a prop is not passed",
            },
            {
                id: "r-3-7",
                question: "What is PropTypes used for?",
                options: [
                    "Styling components",
                    "Runtime type-checking for props to catch errors during development",
                    "Managing global state",
                    "Routing between pages",
                ],
                answer: "Runtime type-checking for props to catch errors during development",
            },
            {
                id: "r-3-8",
                question: "Can you pass a function as a prop?",
                options: [
                    "No, only strings and numbers can be passed",
                    "Yes, functions are valid props and are often used for event handling callbacks",
                    "Only arrow functions can be passed",
                    "Yes, but only inside a class component",
                ],
                answer: "Yes, functions are valid props and are often used for event handling callbacks",
            },
            {
                id: "r-3-9",
                question: "What is prop drilling?",
                options: [
                    "Deleting props from a component",
                    "Passing props through many layers of components that do not need them",
                    "Using too many props on one component",
                    "Drilling into an object's properties",
                ],
                answer: "Passing props through many layers of components that do not need them",
            },
            {
                id: "r-3-10",
                question: "How do you pass a boolean prop (e.g., disabled=true) in shorthand?",
                options: [
                    "<Button disabled='true' />",
                    "<Button disabled={true} />",
                    "<Button disabled />",
                    "Both B and C are correct",
                ],
                answer: "Both B and C are correct",
            },
            {
                id: "r-3-11",
                question: "What is the difference between props and state?",
                options: [
                    "Props and state are the same thing",
                    "Props are passed from parent to child and read-only; state is local and mutable",
                    "State is passed from parent to child; props are internal",
                    "Props can only hold strings; state can hold any value",
                ],
                answer: "Props are passed from parent to child and read-only; state is local and mutable",
            },
            {
                id: "r-3-12",
                question: "Can a child component pass data back up to its parent?",
                options: [
                    "No, data only flows down in React",
                    "Yes, by calling a function passed down as a prop from the parent",
                    "Yes, using props directly",
                    "Only in class components",
                ],
                answer: "Yes, by calling a function passed down as a prop from the parent",
            },
            {
                id: "r-3-13",
                question: "What happens when a prop value changes in the parent?",
                options: [
                    "The child component never re-renders",
                    "The child component re-renders with the new prop value",
                    "The parent re-renders but not the child",
                    "An error is thrown",
                ],
                answer: "The child component re-renders with the new prop value",
            },
            {
                id: "r-3-14",
                question: "Which is the correct way to pass an object as a prop?",
                options: [
                    "<Card user='{ name: 'Riya' }' />",
                    "<Card user={{ name: 'Riya' }} />",
                    "<Card user=[{ name: 'Riya' }] />",
                    "<Card user:(name: 'Riya') />",
                ],
                answer: "<Card user={{ name: 'Riya' }} />",
            },
            {
                id: "r-3-15",
                question: "What does the spread operator do when used with props?",
                options: [
                    "Deletes all props",
                    "Passes all properties of an object as individual props",
                    "Creates a copy of the component",
                    "Merges two components",
                ],
                answer: "Passes all properties of an object as individual props",
            },
        ],
    },
    {
        module: "Day 4 – State & useState Hook",
        questions: [
            {
                id: "r-4-1",
                question: "What is state in React?",
                options: [
                    "A CSS variable",
                    "Data that belongs to a component and can change over time, triggering re-renders",
                    "A global JavaScript variable",
                    "A type of prop",
                ],
                answer: "Data that belongs to a component and can change over time, triggering re-renders",
            },
            {
                id: "r-4-2",
                question: "How do you declare a state variable using the useState hook?",
                options: [
                    "const state = useState(0);",
                    "const [count, setCount] = useState(0);",
                    "let count = useState(0);",
                    "const count = useStateValue(0);",
                ],
                answer: "const [count, setCount] = useState(0);",
            },
            {
                id: "r-4-3",
                question: "What does the setState function (e.g., setCount) do?",
                options: [
                    "It directly changes the state variable",
                    "It schedules an update to the state value and triggers a re-render",
                    "It resets the component to its default state",
                    "It reads the current state value",
                ],
                answer: "It schedules an update to the state value and triggers a re-render",
            },
            {
                id: "r-4-4",
                question: "Can you directly modify a state variable in React?",
                options: [
                    "Yes, you can assign a new value directly",
                    "No, you must always use the state setter function",
                    "Yes, but only inside useEffect",
                    "Only in class components",
                ],
                answer: "No, you must always use the state setter function",
            },
            {
                id: "r-4-5",
                question: "What is the initial value in useState(0)?",
                options: [
                    "The state will always be 0",
                    "0 is the starting value of the state on the first render",
                    "0 is the final value the state resets to",
                    "The component renders zero times",
                ],
                answer: "0 is the starting value of the state on the first render",
            },
            {
                id: "r-4-6",
                question: "What happens when state changes in a component?",
                options: [
                    "The entire page is reloaded",
                    "The component and its children re-render",
                    "Only the changed state variable is updated without re-rendering",
                    "All components in the app re-render",
                ],
                answer: "The component and its children re-render",
            },
            {
                id: "r-4-7",
                question: "How do you update state based on the previous state value safely?",
                options: [
                    "setCount(count + 1)",
                    "setCount(prev => prev + 1)",
                    "count = count + 1",
                    "state.count++",
                ],
                answer: "setCount(prev => prev + 1)",
            },
            {
                id: "r-4-8",
                question: "What is a hook in React?",
                options: [
                    "A CSS styling utility",
                    "A special function that lets you use React features like state inside functional components",
                    "A lifecycle method for class components",
                    "An event listener",
                ],
                answer: "A special function that lets you use React features like state inside functional components",
            },
            {
                id: "r-4-9",
                question: "Where must you always call hooks in a React component?",
                options: [
                    "Inside loops or conditions",
                    "At the top level of the component, before any early returns",
                    "Inside event handlers",
                    "After the return statement",
                ],
                answer: "At the top level of the component, before any early returns",
            },
            {
                id: "r-4-10",
                question: "What is 'lifting state up' in React?",
                options: [
                    "Moving state from a child component to a common parent so siblings can share it",
                    "Importing state from another file",
                    "Making state global using Redux",
                    "Adding more variables to a component's state",
                ],
                answer: "Moving state from a child component to a common parent so siblings can share it",
            },
            {
                id: "r-4-11",
                question: "What is controlled component in React?",
                options: [
                    "A component that manages its own DOM",
                    "A form element whose value is controlled by React state",
                    "A component that cannot receive props",
                    "A component rendered conditionally",
                ],
                answer: "A form element whose value is controlled by React state",
            },
            {
                id: "r-4-12",
                question: "Can a React component have multiple state variables?",
                options: [
                    "No, only one per component",
                    "Yes, by calling useState multiple times for different values",
                    "Only in class components",
                    "Only if they are stored in an object",
                ],
                answer: "Yes, by calling useState multiple times for different values",
            },
            {
                id: "r-4-13",
                question: "What is the initial render of a React component?",
                options: [
                    "When the component is destroyed",
                    "The first time React renders and displays the component's JSX",
                    "When the state first changes",
                    "When props are passed to the component",
                ],
                answer: "The first time React renders and displays the component's JSX",
            },
            {
                id: "r-4-14",
                question: "What is the difference between a React re-render and a page refresh?",
                options: [
                    "They are the same",
                    "A React re-render updates only the changed parts of the UI without reloading the page",
                    "A page refresh is faster",
                    "React re-renders reload all JavaScript files",
                ],
                answer: "A React re-render updates only the changed parts of the UI without reloading the page",
            },
            {
                id: "r-4-15",
                question: "What will happen if you call the state setter function with the same value as the current state?",
                options: [
                    "React will always re-render",
                    "React may bail out of re-rendering if the value has not changed",
                    "An error will be thrown",
                    "The state will be reset to its initial value",
                ],
                answer: "React may bail out of re-rendering if the value has not changed",
            },
        ],
    },
    {
        module: "Day 5 – Handling Events in React",
        questions: [
            {
                id: "r-5-1",
                question: "How do you attach a click event handler in React JSX?",
                options: [
                    "<button onclick='handleClick()'>Click</button>",
                    "<button onClick={handleClick}>Click</button>",
                    "<button click={handleClick}>Click</button>",
                    "<button on-click={handleClick}>Click</button>",
                ],
                answer: "<button onClick={handleClick}>Click</button>",
            },
            {
                id: "r-5-2",
                question: "What are synthetic events in React?",
                options: [
                    "Custom events created using JavaScript",
                    "React wrappers around native browser events that work consistently across browsers",
                    "Events that fire automatically on render",
                    "Events only available in class components",
                ],
                answer: "React wrappers around native browser events that work consistently across browsers",
            },
            {
                id: "r-5-3",
                question: "How do you prevent form submission from reloading the page in React?",
                options: [
                    "Do nothing, React handles it automatically",
                    "Call event.preventDefault() inside the submit handler",
                    "Use a button with type='button' and handle all logic manually",
                    "Both B and C are correct approaches",
                ],
                answer: "Both B and C are correct approaches",
            },
            {
                id: "r-5-4",
                question: "What is a controlled input in React?",
                options: [
                    "An input that is disabled",
                    "An input whose value is managed by React state via value prop and onChange handler",
                    "An input with a built-in validator",
                    "An input that submits automatically",
                ],
                answer: "An input whose value is managed by React state via value prop and onChange handler",
            },
            {
                id: "r-5-5",
                question: "What event fires when input field content changes?",
                options: ["onInput", "onChange", "onEdit", "onUpdate"],
                answer: "onChange",
            },
            {
                id: "r-5-6",
                question: "What does event.target.value give you in an onChange handler?",
                options: [
                    "The type of the input element",
                    "The current value typed into the input",
                    "The name attribute of the input",
                    "The position of the cursor",
                ],
                answer: "The current value typed into the input",
            },
            {
                id: "r-5-7",
                question: "How do you pass extra arguments to an event handler?",
                options: [
                    "handleClick(id) directly in JSX",
                    "onClick={() => handleClick(id)}",
                    "onClick={handleClick.bind(id)}",
                    "Both B and C are valid",
                ],
                answer: "Both B and C are valid",
            },
            {
                id: "r-5-8",
                question: "What event fires when a key is pressed on a focused element?",
                options: ["onKeyPress", "onKeyDown", "onKey", "Both onKeyPress and onKeyDown"],
                answer: "Both onKeyPress and onKeyDown",
            },
            {
                id: "r-5-9",
                question: "What event fires when an element loses focus?",
                options: ["onBlur", "onFocusLost", "onUnfocus", "onLeave"],
                answer: "onBlur",
            },
            {
                id: "r-5-10",
                question: "What is event.target in a React event handler?",
                options: [
                    "The event object",
                    "The DOM element that triggered the event",
                    "The React component",
                    "The state object",
                ],
                answer: "The DOM element that triggered the event",
            },
            {
                id: "r-5-11",
                question: "What happens to the event object in React after the event handler runs?",
                options: [
                    "It persists indefinitely",
                    "It is nullified (in older React) though modern React keeps it available",
                    "It is sent to the parent component",
                    "It is stored in state automatically",
                ],
                answer: "It is nullified (in older React) though modern React keeps it available",
            },
            {
                id: "r-5-12",
                question: "What event fires when a file is selected in an input of type='file'?",
                options: ["onSelect", "onChange", "onUpload", "onFileSelect"],
                answer: "onChange",
            },
            {
                id: "r-5-13",
                question: "Which approach is recommended for inline event handlers in React?",
                options: [
                    "Using inline HTML event attributes",
                    "Using arrow functions or named handler functions in the JSX",
                    "Setting events directly on DOM nodes",
                    "Using jQuery event bindings",
                ],
                answer: "Using arrow functions or named handler functions in the JSX",
            },
            {
                id: "r-5-14",
                question: "What event fires when the mouse hovers over an element?",
                options: ["onHover", "onMouseEnter", "onMouseOver", "Both onMouseEnter and onMouseOver"],
                answer: "Both onMouseEnter and onMouseOver",
            },
            {
                id: "r-5-15",
                question: "When passing an event handler without calling it, which is correct?",
                options: [
                    "onClick={handleClick()}",
                    "onClick={handleClick}",
                    "onClick='handleClick'",
                    "onClick=handleClick",
                ],
                answer: "onClick={handleClick}",
            },
        ],
    },
    {
        module: "Day 6 – useEffect Hook & Side Effects",
        questions: [
            {
                id: "r-6-1",
                question: "What is a side effect in React?",
                options: [
                    "An error caused by incorrect state updates",
                    "Operations like data fetching and subscriptions that happen outside pure rendering",
                    "A negative consequence of using hooks",
                    "A CSS animation triggered by state",
                ],
                answer: "Operations like data fetching and subscriptions that happen outside pure rendering",
            },
            {
                id: "r-6-2",
                question: "What does useEffect(() => {}, []) do?",
                options: [
                    "Runs on every render",
                    "Runs only once after the first render, like componentDidMount",
                    "Never runs",
                    "Runs before the first render",
                ],
                answer: "Runs only once after the first render, like componentDidMount",
            },
            {
                id: "r-6-3",
                question: "What does useEffect(() => {}) (without a dependency array) do?",
                options: [
                    "Runs once after the first render",
                    "Runs after every render",
                    "Never runs",
                    "Runs only when the component unmounts",
                ],
                answer: "Runs after every render",
            },
            {
                id: "r-6-4",
                question: "What does the dependency array in useEffect control?",
                options: [
                    "The order of hooks in the component",
                    "Which state or prop values, when changed, cause the effect to re-run",
                    "The initial state values",
                    "The component that is rendered",
                ],
                answer: "Which state or prop values, when changed, cause the effect to re-run",
            },
            {
                id: "r-6-5",
                question: "What does the cleanup function returned from useEffect do?",
                options: [
                    "Clears the component's state",
                    "Runs before the next effect or when the component unmounts to clean up",
                    "Cancels the last setState call",
                    "Removes the component from the DOM",
                ],
                answer: "Runs before the next effect or when the component unmounts to clean up",
            },
            {
                id: "r-6-6",
                question: "What is the correct way to fetch data inside useEffect?",
                options: [
                    "Make useEffect itself async",
                    "Define an async function inside useEffect, then call it immediately",
                    "Use fetch() directly without async/await",
                    "Fetch data before the component renders",
                ],
                answer: "Define an async function inside useEffect, then call it immediately",
            },
            {
                id: "r-6-7",
                question: "What is a common reason for an infinite loop when using useEffect?",
                options: [
                    "Having no dependency array",
                    "Setting state inside useEffect without correct dependencies, causing endless re-renders",
                    "Using multiple useEffect hooks",
                    "Using async functions inside useEffect",
                ],
                answer: "Setting state inside useEffect without correct dependencies, causing endless re-renders",
            },
            {
                id: "r-6-8",
                question: "What is the equivalent of componentWillUnmount in hooks?",
                options: [
                    "The return function from useState",
                    "A cleanup function returned from useEffect",
                    "A special useUnmount() hook",
                    "The useCallback hook",
                ],
                answer: "A cleanup function returned from useEffect",
            },
            {
                id: "r-6-9",
                question: "Which hook is used for subscribing to an external data source?",
                options: ["useRef", "useEffect", "useMemo", "useCallback"],
                answer: "useEffect",
            },
            {
                id: "r-6-10",
                question: "When should you use useEffect?",
                options: [
                    "To update state synchronously",
                    "To perform side effects like API calls, subscriptions, or DOM manipulation after render",
                    "To derive new values from existing state",
                    "To handle click events",
                ],
                answer: "To perform side effects like API calls, subscriptions, or DOM manipulation after render",
            },
            {
                id: "r-6-11",
                question: "What is useLayoutEffect different from useEffect?",
                options: [
                    "useLayoutEffect only runs once",
                    "useLayoutEffect runs synchronously after DOM mutations but before the browser paints",
                    "useLayoutEffect does not accept a dependency array",
                    "They are identical",
                ],
                answer: "useLayoutEffect runs synchronously after DOM mutations but before the browser paints",
            },
            {
                id: "r-6-12",
                question: "What hook allows you to access a DOM element directly without triggering a re-render?",
                options: ["useState", "useEffect", "useRef", "useContext"],
                answer: "useRef",
            },
            {
                id: "r-6-13",
                question: "What will happen if you include a function in the dependency array of useEffect?",
                options: [
                    "The effect will never re-run",
                    "The effect may re-run on every render because a new function reference is created each time",
                    "An error will be thrown",
                    "The function will be called immediately",
                ],
                answer: "The effect may re-run on every render because a new function reference is created each time",
            },
            {
                id: "r-6-14",
                question: "What does the useCallback hook do?",
                options: [
                    "Runs a callback after every render",
                    "Memoizes a function reference so it does not change on every render",
                    "Converts a class method to a hook",
                    "Creates a callback from a promise",
                ],
                answer: "Memoizes a function reference so it does not change on every render",
            },
            {
                id: "r-6-15",
                question: "What does the useMemo hook do?",
                options: [
                    "Memoizes a component to prevent re-renders",
                    "Caches the result of an expensive calculation and recalculates only when dependencies change",
                    "Stores a callback function in memory",
                    "Remembers the previous state value",
                ],
                answer: "Caches the result of an expensive calculation and recalculates only when dependencies change",
            },
        ],
    },
    {
        module: "Day 7 – React Router: Client-Side Navigation",
        questions: [
            {
                id: "r-7-1",
                question: "What is React Router used for?",
                options: [
                    "Managing component state",
                    "Enabling client-side navigation between pages in a React application",
                    "Fetching data from APIs",
                    "Styling React components",
                ],
                answer: "Enabling client-side navigation between pages in a React application",
            },
            {
                id: "r-7-2",
                question: "Which component wraps your app to enable React Router?",
                options: ["<Router>", "<BrowserRouter>", "<Navigate>", "<Switch>"],
                answer: "<BrowserRouter>",
            },
            {
                id: "r-7-3",
                question: "Which component defines a route in React Router v6?",
                options: ["<Route>", "<Path>", "<Route /> inside <Routes>", "<Link>"],
                answer: "<Route /> inside <Routes>",
            },
            {
                id: "r-7-4",
                question: "What component should you use instead of an <a> tag for navigation in React Router?",
                options: ["<Navigate>", "<a href>", "<Link>", "<Redirect>"],
                answer: "<Link>",
            },
            {
                id: "r-7-5",
                question: "What hook gives you the current route parameters?",
                options: ["useRoute", "useParams", "useRouteParams", "useNavigate"],
                answer: "useParams",
            },
            {
                id: "r-7-6",
                question: "What does the useNavigate hook return?",
                options: [
                    "The current URL",
                    "A function that allows programmatic navigation",
                    "The browser history object",
                    "The current route parameters",
                ],
                answer: "A function that allows programmatic navigation",
            },
            {
                id: "r-7-7",
                question: "How do you navigate to the home page programmatically?",
                options: [
                    "window.location = '/'",
                    "navigate('/')",
                    "Link.to('/')",
                    "router.push('/')",
                ],
                answer: "navigate('/')",
            },
            {
                id: "r-7-8",
                question: "What is a nested route in React Router?",
                options: [
                    "A route with many parameters",
                    "A route rendered inside another route's component",
                    "A route that redirects to another route",
                    "A route with a wildcard path",
                ],
                answer: "A route rendered inside another route's component",
            },
            {
                id: "r-7-9",
                question: "What does the <Outlet> component render in nested routing?",
                options: [
                    "The parent component's content",
                    "The matching child route's component",
                    "A loading spinner",
                    "A 404 page",
                ],
                answer: "The matching child route's component",
            },
            {
                id: "r-7-10",
                question: "What is the purpose of a wildcard route path='*' in React Router?",
                options: [
                    "To match all named routes",
                    "To catch all unmatched routes, typically showing a 404 Not Found page",
                    "To apply to all components",
                    "To redirect to the home page",
                ],
                answer: "To catch all unmatched routes, typically showing a 404 Not Found page",
            },
            {
                id: "r-7-11",
                question: "What hook returns the current location (pathname, search, hash) in React Router?",
                options: ["useRoute", "useLocation", "useHistory", "usePathname"],
                answer: "useLocation",
            },
            {
                id: "r-7-12",
                question: "What is NavLink different from Link in React Router?",
                options: [
                    "NavLink can navigate to external URLs",
                    "NavLink automatically applies an 'active' class to the link that matches the current route",
                    "NavLink does not change the URL",
                    "NavLink requires a to and from prop",
                ],
                answer: "NavLink automatically applies an 'active' class to the link that matches the current route",
            },
            {
                id: "r-7-13",
                question: "What is a route parameter in React Router?",
                options: [
                    "A query string in the URL",
                    "A dynamic segment of the path defined with a colon like :id",
                    "A hash fragment in the URL",
                    "A prop passed to the Route component",
                ],
                answer: "A dynamic segment of the path defined with a colon like :id",
            },
            {
                id: "r-7-14",
                question: "How do you pass query strings in React Router and access them?",
                options: [
                    "Via route parameters with useParams",
                    "By appending ?key=value to the link and reading with useSearchParams",
                    "Via the state prop on Link",
                    "Query strings are not supported in React Router",
                ],
                answer: "By appending ?key=value to the link and reading with useSearchParams",
            },
            {
                id: "r-7-15",
                question: "What does client-side navigation mean in a React SPA?",
                options: [
                    "The server sends a new HTML page on every click",
                    "The browser renders different components based on the URL without a full page reload",
                    "Navigation is handled by the database",
                    "CSS transitions handle all navigation",
                ],
                answer: "The browser renders different components based on the URL without a full page reload",
            },
        ],
    },
    {
        module: "Day 8 – Context API: Sharing Global State",
        questions: [
            {
                id: "r-8-1",
                question: "What problem does the Context API solve?",
                options: [
                    "Slow rendering of large lists",
                    "Prop drilling: avoiding passing props through many layers of components",
                    "Asynchronous data fetching",
                    "Styling components dynamically",
                ],
                answer: "Prop drilling: avoiding passing props through many layers of components",
            },
            {
                id: "r-8-2",
                question: "How do you create a context in React?",
                options: [
                    "const MyContext = new Context();",
                    "const MyContext = React.createContext(defaultValue);",
                    "const MyContext = useContext();",
                    "const MyContext = Context.create();",
                ],
                answer: "const MyContext = React.createContext(defaultValue);",
            },
            {
                id: "r-8-3",
                question: "What component provides context values to its descendants?",
                options: [
                    "<MyContext.Receiver>",
                    "<MyContext.Provider value={...}>",
                    "<MyContext.Wrapper>",
                    "<ContextGiver>",
                ],
                answer: "<MyContext.Provider value={...}>",
            },
            {
                id: "r-8-4",
                question: "What hook reads values from a context?",
                options: ["useState", "useEffect", "useContext", "useReducer"],
                answer: "useContext",
            },
            {
                id: "r-8-5",
                question: "What happens when a context value changes?",
                options: [
                    "Only the provider component re-renders",
                    "All consumers of that context re-render",
                    "Nothing re-renders",
                    "Only the root component re-renders",
                ],
                answer: "All consumers of that context re-render",
            },
            {
                id: "r-8-6",
                question: "Can you have multiple contexts in a React application?",
                options: [
                    "No, only one context is allowed",
                    "Yes, you can create and nest multiple contexts for different concerns",
                    "Only in class components",
                    "Yes, but only for authenticated routes",
                ],
                answer: "Yes, you can create and nest multiple contexts for different concerns",
            },
            {
                id: "r-8-7",
                question: "What is a common pattern when using Context with state?",
                options: [
                    "Storing all state inside the context object directly",
                    "Using useState inside a Provider component and passing state and setState as context value",
                    "Calling useContext inside the Provider",
                    "Defining context inside each component",
                ],
                answer: "Using useState inside a Provider component and passing state and setState as context value",
            },
            {
                id: "r-8-8",
                question: "What is the default value of a context used for?",
                options: [
                    "The value always shown regardless of the Provider",
                    "The fallback value consumed when a component is not wrapped inside a Provider",
                    "The initial state of the Provider",
                    "The error message shown if context fails",
                ],
                answer: "The fallback value consumed when a component is not wrapped inside a Provider",
            },
            {
                id: "r-8-9",
                question: "Is Context API a replacement for Redux?",
                options: [
                    "Yes, always",
                    "No, Redux is better suited for complex state with many actions; Context is good for simpler global state",
                    "Context replaces Redux in large applications",
                    "Redux replaces Context in small applications",
                ],
                answer: "No, Redux is better suited for complex state with many actions; Context is good for simpler global state",
            },
            {
                id: "r-8-10",
                question: "What hook can be used alongside Context for more complex state management?",
                options: ["useEffect", "useReducer", "useMemo", "useRef"],
                answer: "useReducer",
            },
            {
                id: "r-8-11",
                question: "What does useReducer return?",
                options: [
                    "state and a dispatch function",
                    "state and setState",
                    "An array of previous states",
                    "A context object",
                ],
                answer: "state and a dispatch function",
            },
            {
                id: "r-8-12",
                question: "When should you prefer useReducer over useState?",
                options: [
                    "For simple toggle states",
                    "When state logic involves multiple sub-values or complex update conditions",
                    "When you do not want re-renders",
                    "For fetching data",
                ],
                answer: "When state logic involves multiple sub-values or complex update conditions",
            },
            {
                id: "r-8-13",
                question: "What is a common performance concern with Context API?",
                options: [
                    "Context cannot be combined with hooks",
                    "All consumers re-render when the context value changes, even if only part of the value changed",
                    "Context does not work in functional components",
                    "Context makes the bundle size too large",
                ],
                answer: "All consumers re-render when the context value changes, even if only part of the value changed",
            },
            {
                id: "r-8-14",
                question: "What is the best practice for organising context in a large React application?",
                options: [
                    "Put all global state in one massive context",
                    "Split context into smaller focused contexts for different concerns like auth, theme, and cart",
                    "Use only useState and avoid context entirely",
                    "Replace all context with localStorage",
                ],
                answer: "Split context into smaller focused contexts for different concerns like auth, theme, and cart",
            },
            {
                id: "r-8-15",
                question: "What does React.memo() do for context consumers?",
                options: [
                    "It automatically memoizes context values",
                    "It prevents a component from re-rendering if its props have not changed",
                    "It caches the context value",
                    "It replaces useContext",
                ],
                answer: "It prevents a component from re-rendering if its props have not changed",
            },
        ],
    },
    {
        module: "Day 9 – Custom Hooks",
        questions: [
            {
                id: "r-9-1",
                question: "What is a custom hook in React?",
                options: [
                    "A built-in React hook with extra features",
                    "A reusable function that uses one or more React hooks to encapsulate and share stateful logic",
                    "A CSS utility function",
                    "An event handler stored in a separate file",
                ],
                answer: "A reusable function that uses one or more React hooks to encapsulate and share stateful logic",
            },
            {
                id: "r-9-2",
                question: "How must a custom hook name start?",
                options: ["With an uppercase letter", "With 'hook'", "With 'use'", "With an underscore"],
                answer: "With 'use'",
            },
            {
                id: "r-9-3",
                question: "What is the benefit of using custom hooks?",
                options: [
                    "Better CSS performance",
                    "Extracting and reusing stateful logic without code duplication across components",
                    "Reducing the number of useEffect calls",
                    "Making components render faster automatically",
                ],
                answer: "Extracting and reusing stateful logic without code duplication across components",
            },
            {
                id: "r-9-4",
                question: "Can custom hooks use other hooks inside them?",
                options: [
                    "No, custom hooks must be pure functions",
                    "Yes, custom hooks can call any built-in or other custom hooks",
                    "Only useState and useEffect are allowed",
                    "Only one hook can be used at a time",
                ],
                answer: "Yes, custom hooks can call any built-in or other custom hooks",
            },
            {
                id: "r-9-5",
                question: "What does a custom useFetch hook typically encapsulate?",
                options: [
                    "Authentication logic",
                    "API fetch call, loading state, error state, and the data state",
                    "CSS transitions",
                    "DOM event listeners",
                ],
                answer: "API fetch call, loading state, error state, and the data state",
            },
            {
                id: "r-9-6",
                question: "Why is it good practice to create a useWindowSize custom hook?",
                options: [
                    "To make the window smaller",
                    "To encapsulate the window resize event logic and share it across components",
                    "To access the browser's window object",
                    "To manage CSS media queries",
                ],
                answer: "To encapsulate the window resize event logic and share it across components",
            },
            {
                id: "r-9-7",
                question: "Is state in a custom hook shared between all components that use it?",
                options: [
                    "Yes, state is always shared",
                    "No, each component using the hook gets its own independent state and effects",
                    "Only if the hook uses context",
                    "It depends on whether the hook uses useRef",
                ],
                answer: "No, each component using the hook gets its own independent state and effects",
            },
            {
                id: "r-9-8",
                question: "What is the purpose of a useDebounce custom hook?",
                options: [
                    "To remove bugs from the application",
                    "To delay updating a value until the user stops typing for a specified time",
                    "To batch multiple state updates together",
                    "To increase rendering speed",
                ],
                answer: "To delay updating a value until the user stops typing for a specified time",
            },
            {
                id: "r-9-9",
                question: "What should a custom hook return?",
                options: [
                    "Always a JSX element",
                    "Whatever the consuming component needs: state values, handlers, or other data",
                    "Only a single value",
                    "Must return an object",
                ],
                answer: "Whatever the consuming component needs: state values, handlers, or other data",
            },
            {
                id: "r-9-10",
                question: "Where are custom hooks typically defined?",
                options: [
                    "Directly inside components",
                    "In a dedicated hooks folder or file, exported as named functions",
                    "Inside CSS modules",
                    "In the node_modules folder",
                ],
                answer: "In a dedicated hooks folder or file, exported as named functions",
            },
            {
                id: "r-9-11",
                question: "Can you use a custom hook conditionally?",
                options: [
                    "Yes, inside an if statement",
                    "No, hooks must always be called in the same order and not inside conditions",
                    "Only if the condition is based on props",
                    "Yes, but only at the bottom of the component",
                ],
                answer: "No, hooks must always be called in the same order and not inside conditions",
            },
            {
                id: "r-9-12",
                question: "What is the useLocalStorage custom hook pattern useful for?",
                options: [
                    "Reading files from the local file system",
                    "Persisting state to localStorage so it survives page refreshes",
                    "Loading images from a local folder",
                    "Caching server-side data",
                ],
                answer: "Persisting state to localStorage so it survives page refreshes",
            },
            {
                id: "r-9-13",
                question: "When is it a good idea to create a custom hook?",
                options: [
                    "Whenever you have more than two state variables",
                    "When the same stateful logic is repeated in more than one component",
                    "When you want to improve CSS performance",
                    "When a component has more than 100 lines",
                ],
                answer: "When the same stateful logic is repeated in more than one component",
            },
            {
                id: "r-9-14",
                question: "What does the useToggle custom hook typically do?",
                options: [
                    "Toggles the visibility of a modal",
                    "Provides a boolean state and a function to switch it between true and false",
                    "Toggles between two colour themes",
                    "Switches between two components",
                ],
                answer: "Provides a boolean state and a function to switch it between true and false",
            },
            {
                id: "r-9-15",
                question: "How does using custom hooks improve code quality?",
                options: [
                    "By removing the need for props entirely",
                    "By keeping components clean and focused on UI while logic lives in reusable hooks",
                    "By automatically optimising performance",
                    "By replacing the need for state in components",
                ],
                answer: "By keeping components clean and focused on UI while logic lives in reusable hooks",
            },
        ],
    },
    {
        module: "Day 10 – Final React Project Concepts",
        questions: [
            {
                id: "r-10-1",
                question: "What is React.memo() used for?",
                options: [
                    "To memoize context values",
                    "To prevent a component from re-rendering if its props have not changed",
                    "To cache API responses",
                    "To import a module only once",
                ],
                answer: "To prevent a component from re-rendering if its props have not changed",
            },
            {
                id: "r-10-2",
                question: "What is code splitting in React?",
                options: [
                    "Splitting your code into multiple GitHub branches",
                    "Loading only the parts of the app needed for the current page to improve performance",
                    "Dividing a component into smaller files",
                    "Separating CSS from JavaScript",
                ],
                answer: "Loading only the parts of the app needed for the current page to improve performance",
            },
            {
                id: "r-10-3",
                question: "What does React.lazy() do?",
                options: [
                    "Makes a component load slowly for dramatic effect",
                    "Dynamically imports a component so it only loads when needed",
                    "Delays the initial render of the app",
                    "Caches component output",
                ],
                answer: "Dynamically imports a component so it only loads when needed",
            },
            {
                id: "r-10-4",
                question: "What is <Suspense> used for in React?",
                options: [
                    "To pause all rendering",
                    "To show a fallback UI while a lazy-loaded component or async operation hasn't finished",
                    "To wrap error boundaries",
                    "To delay state updates",
                ],
                answer: "To show a fallback UI while a lazy-loaded component or async operation hasn't finished",
            },
            {
                id: "r-10-5",
                question: "What is an Error Boundary in React?",
                options: [
                    "A utility to log errors to a server",
                    "A class component that catches JavaScript errors in its child tree and shows a fallback UI",
                    "A custom hook for handling fetch errors",
                    "A debugging tool in React DevTools",
                ],
                answer: "A class component that catches JavaScript errors in its child tree and shows a fallback UI",
            },
            {
                id: "r-10-6",
                question: "What is the purpose of the React DevTools browser extension?",
                options: [
                    "To write React code in the browser",
                    "To inspect component trees, view props and state, and profile performance",
                    "To deploy React applications",
                    "To manage npm packages",
                ],
                answer: "To inspect component trees, view props and state, and profile performance",
            },
            {
                id: "r-10-7",
                question: "What does npm run build do in a React project?",
                options: [
                    "Starts the development server",
                    "Creates an optimised production build for deployment",
                    "Runs all tests",
                    "Installs dependencies",
                ],
                answer: "Creates an optimised production build for deployment",
            },
            {
                id: "r-10-8",
                question: "What is prop-types vs TypeScript for React?",
                options: [
                    "They are the same tool",
                    "prop-types checks types at runtime; TypeScript checks types at compile time",
                    "TypeScript only works with class components",
                    "prop-types is more powerful than TypeScript",
                ],
                answer: "prop-types checks types at runtime; TypeScript checks types at compile time",
            },
            {
                id: "r-10-9",
                question: "What is the best practice for organising a React project's folder structure?",
                options: [
                    "Put all files in the root folder",
                    "Group files by feature or type: components, hooks, context, pages, and utils",
                    "Use only one component file",
                    "Name all files with numbers",
                ],
                answer: "Group files by feature or type: components, hooks, context, pages, and utils",
            },
            {
                id: "r-10-10",
                question: "What is accessibility (a11y) in the context of React applications?",
                options: [
                    "Making the app load faster",
                    "Ensuring the app can be used by people with disabilities, including screen reader support",
                    "Adding keyboard shortcuts for power users",
                    "Making the app work on old browsers",
                ],
                answer: "Ensuring the app can be used by people with disabilities, including screen reader support",
            },
            {
                id: "r-10-11",
                question: "What is the purpose of aria-label in React?",
                options: [
                    "To apply CSS styles",
                    "To provide an accessible name for an element that screen readers announce",
                    "To label React components in DevTools",
                    "To add a tooltip on hover",
                ],
                answer: "To provide an accessible name for an element that screen readers announce",
            },
            {
                id: "r-10-12",
                question: "What does role='button' do on a non-button element?",
                options: [
                    "Makes it look like a button",
                    "Tells assistive technologies to treat the element as a button for accessibility",
                    "Adds click functionality automatically",
                    "Changes the element's HTML tag",
                ],
                answer: "Tells assistive technologies to treat the element as a button for accessibility",
            },
            {
                id: "r-10-13",
                question: "Why is tabIndex={0} important on interactive elements in React?",
                options: [
                    "It moves the element to the top of the page",
                    "It makes the element focusable with the keyboard Tab key",
                    "It adds a visible focus ring automatically",
                    "It prevents default browser behaviour",
                ],
                answer: "It makes the element focusable with the keyboard Tab key",
            },
            {
                id: "r-10-14",
                question: "What is unit testing and which library is commonly used for React?",
                options: [
                    "Checking each function manually; React DevTools",
                    "Automated testing of individual pieces of code; React Testing Library with Jest",
                    "Testing the entire application end-to-end; Cypress",
                    "Visual testing in the browser; Storybook",
                ],
                answer: "Automated testing of individual pieces of code; React Testing Library with Jest",
            },
            {
                id: "r-10-15",
                question: "What makes a good React application in terms of architecture?",
                options: [
                    "One large component with all logic inside",
                    "Small, focused, reusable components with separated concerns, proper state management, and accessibility",
                    "No use of hooks or context",
                    "Inline styles for all elements",
                ],
                answer: "Small, focused, reusable components with separated concerns, proper state management, and accessibility",
            },
        ],
    },
];
